export const GET_TOURNAMENTS_HOME_INFO = "GET_TOURNAMENTS_HOME_INFO";
export const GET_ALL_CHAMPIONSHIPS = "GET_ALL_CHAMPIONSHIPS";